<template>
  <div class="">
    <slot name="title" />

    <button
      class="link mb-4 link-primary"
      @click="addAddressPopup=(true)"
    >
      Add An Address
    </button>
    <PopUp v-if="addAddressPopup">
      <template #popuptitle>
        New Address
      </template>
      <template #exitbtn> 
        <button
          class="w-full h-full"
          @click="addAddressPopup=false"
        >
          X
        </button>
      </template>
      <v-form
        ref="valid"
        @submit.prevent
      >
        <div
          class="twocolinputs"
        >
          <v-text-field
            id="firstName"
            v-model="shippingInfo.firstName"
            :rules="[rules.required]"
            type="text"
            label="First Name"
          />
          <v-text-field
            id="lastName"
            v-model="shippingInfo.lastName"
            :rules="[rules.required]"
            type="text"
            label="Last Name"
          />
          <v-text-field
            id="address1"
            v-model="shippingInfo.address1"
            :rules="[rules.required]"
            type="text"
            label="Shipping Address"
          />
          <v-text-field
            id="address2"
            v-model="shippingInfo.address2"
            type="text"
            label="Address Line 2"
          />
          <v-text-field
            id="city"
            v-model="shippingInfo.city"
            :rules="[rules.required]"
            type="text"
            label="City"
          />
          <v-text-field
            id="region"
            v-model="shippingInfo.region"
            :rules="[rules.required, rules.state]"
            type="text"
            label="State"
          />
          <v-text-field
            id="zip"
            v-model="shippingInfo.zip"
            :rules="[rules.required, rules.zip]"
            type="text"
            label="Zip Code"
          />
        </div>
        <div class="vbtn w-full btn-secondary text-secondary-content">
          <v-btn
            type="submit"
            variant="text"
            class="w-full"
            @click="newShippingProfile(shippingInfo)"
          >
            Save
          </v-btn>
        </div>
      </v-form>
    </PopUp>
  </div>
  <div
    v-if="allShippingProfiles && allShippingProfiles.length>0"
  >
    <v-form>
      <!--New Radio-->
      <div
        v-for="(ship,idx) in allShippingProfiles"
        :key="idx"
        class="form-control"
      >
        <label class="label cursor-pointer ">
          <input
            type="radio"
            name="shippingaddress"
            class="scale-[.85] radio outline-secondary bg-transparent outline checked:bg-secondary"
            checked
            @click="useUserDataStore().userData.selectedShippingInfo = ship;"
          >
          <div class="w-full ml-2 text-left flex align-center">
            <p class=""><strong class="p-2">{{ ship.firstName }} {{ ship.lastName }} </strong>
              {{ ship.address1 }}, {{ ship.address2.length>0 ? ship.address2 + ", " + ship.city : ship.city }}, {{ ship.region }}, {{ ship.zip }}</p>
            <v-btn
              variant="icon"
              class="p-0"
              icon="mdi-trash-can-outline"
              @click="deleteIdx=idx;deleteAddressPopup=true"
            />
            <PopUp v-if="deleteAddressPopup">
              <template #popuptitle>
                Delete Address
              </template>
              <template #exitbtn> 
                <button
                  class="w-full h-full"
                  @click="deleteAddressPopup=false"
                >
                  X
                </button>
              </template>
              <p>
                Are you sure you would like to remove this address from your profile?
              </p>
              <p class="text-center my-2">{{ allShippingProfiles[deleteIdx].address1 }}, {{ allShippingProfiles[deleteIdx].address2.length>0 ? allShippingProfiles[deleteIdx].address2 + ", " + allShippingProfiles[deleteIdx].city : allShippingProfiles[deleteIdx].city }}, {{ allShippingProfiles[deleteIdx].region }}, {{ allShippingProfiles[deleteIdx].zip }}</p>
              <br>
              <div class="twocolinputs">
                <button
                  class="btn w-full btn-neutral"
                  @click="deleteAddressPopup=false"
                >
                  Close
                </button>
                <button
                  class="btn btn-neutral w-full"
                  @click="isEqual(useUserDataStore().userData.selectedShippingInfo,useUserDataStore().userData.shippingInfo[deleteIdx])?useUserDataStore().userData.selectedShippingInfo={firstName:'',lastName:'',address1:'',address2:'',city:'',region:'',zip:'',country:'US'}:null;useUserDataStore().userData.shippingInfo.splice(deleteIdx,1); deleteAddressPopup = false"
                >
                  Delete
                </button>
              </div>
            </PopUp>
          </div> 
        </label>
      </div>
      <!--Original Radio-->
      <!-- <input
          type="checkbox"
          name="shippingaddress"
          class="checkbox bg-base-100 outline checkbox-outline"
          :value="ship"
          @click="useUserDataStore().userData.selectedShippingInfo = ship;"
        >


        TEMP
        useUserDataStore().userData.shippingInfo = filter(useUserDataStore().userData.shippingInfo,(val, yandex)=>{return deleteIdx!=yandex})


        <span class="w-full ml-4 text-left flex">
          <p><strong class="p-2">{{ ship.firstName }} {{ ship.lastName }} </strong>
            {{ ship.address1 }}, {{ ship.address2.length>0 ? ship.address2 + ", " + ship.city : ship.city }}, {{ ship.region }}, {{ ship.zip }}</p>
          <button
            class="btn-circle"
            @click="deleteshipaddress=true"
          >
            <v-icon icon="mdi-trash-can-outline" />
          </button>
            
        </span> 
      </input-->
    </v-form>
  </div>
</template>

<script setup>
import { useUserDataStore } from '../stores/userData'
import { isEqual } from 'lodash-es'


const addAddressPopup = ref(false)
const allShippingProfiles = ref()
const valid = ref()
const shippingInfo = ref({firstName:'',lastName:'',address1:'',address2:'',city:'',region:'',zip:'',country:'US'})
const shipaddressdialog = ref(false)
const deleteAddressPopup = ref(false)
const deleteIdx = ref()

const rules = ref({
  required: value => !!value || 'Required.',
  state:v=>states.includes(v.toUpperCase())||'Invalid State',
  zip:v=> (!isNaN(v) && v<99999 && v>0) ||'Invalid Zip'
})

const states = [ 'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY' ];


watch(useUserDataStore(),(userStore)=>{
  allShippingProfiles.value = userStore.userData.shippingInfo
})

onMounted(()=>{
  allShippingProfiles.value = useUserDataStore().userData.shippingInfo
})

const newShippingProfile = async(newShip) => {
  console.log(await valid.value.validate())
  if((await valid.value.validate()).valid){
    newShip.country="US"
    useUserDataStore().userData.shippingInfo.push(newShip)
    useUserDataStore().userData.selectedShippingInfo = newShip
    //Is there a way to use shipRadioGroup to select our newship object?
    shipaddressdialog.value = false
    addAddressPopup.value = false
    shippingInfo.value ={firstName:'',lastName:'',address1:'',address2:'',city:'',region:'',zip:'',country:'US'}
  }  
}

</script>